import { render, staticRenderFns } from "./CentersWithRequest.vue?vue&type=template&id=6feb7afd&lang=pug&"
import script from "./CentersWithRequest.vue?vue&type=script&lang=js&"
export * from "./CentersWithRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports